var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechRetour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.755676 6.03102C0.480957 5.84498 0.316406 5.5348 0.316406 5.20302C0.316406 4.87124 0.480957 4.56106 0.755676 4.37502L6.14465 0.375023C6.45111 0.166779 6.84766 0.145069 7.17499 0.318611C7.50238 0.492149 7.70697 0.832489 7.70667 1.20302V9.20302C7.70697 9.57358 7.50238 9.91391 7.17499 10.0874C6.8476 10.261 6.45111 10.2393 6.14465 10.031L0.755676 6.03102Z",
    fill: "#5754E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechRetour);
export default __webpack_public_path__ + "static/media/flechRetour.402d428c3bc7ae5c1ed6b408d903e219.svg";
export { ForwardRef as ReactComponent };